import icAddSquare from 'assets/images/ic-add-square.svg'
import icMinusCircle from 'assets/images/ic-minus-circle.svg'
import icDragMove from 'assets/images/ic-drag-move.svg'
import { useRef, useState } from 'react'

export const OtherImages = ({ data, onShowFormUpload, onChange, maxImage }) => {
    const [dragging, setDragging] = useState(false)
    const [currentDragIndex, setCurrentDragIndex] = useState(0)
    const dragNode = useRef()

    const onDeleteHandler = (index) => {
        const copyOtherImages = [...data]
        const newOtherImages = copyOtherImages.filter((_, i) => i !== index)
        onChange(newOtherImages)
    }

    const dragStartHandler = (e, index) => {
        setCurrentDragIndex(index)
        dragNode.current = e?.target
        dragNode.current?.addEventListener('dragend', dragEndHandler)
        setDragging(true)
    }

    const dragEnterHandler = (e, index) => {
        if (e.target !== dragNode.current) {
            const imagesCopy = [...data]
            const DragItem = imagesCopy.splice(currentDragIndex, 1)[0]
            imagesCopy.splice(index, 0, DragItem)
            setCurrentDragIndex(index)
            onChange(imagesCopy)
        }
    }

    const dragEndHandler = () => {
        setCurrentDragIndex(0)
        dragNode.current = null
        dragNode.current?.removeEventListener('dragend', dragEndHandler)
        setDragging(false)
    }

    return (
        <div className={'flex flex-col space-y-3'}>
            <div className={'grid grid-cols-5 gap-4 p-4 border border-neutral-30 rounded'}>
                {data?.map((item, index) => (
                    <div
                        draggable
                        onDragStart={(e) => dragStartHandler(e, index)}
                        onDragEnter={dragging ? (e) => dragEnterHandler(e, index) : () => {}}
                        onDragOver={(e) => e?.preventDefault()}
                        key={index}
                        className={`w-fit relative rounded-md ${!dragging && 'group'}`}
                    >
                        <img
                            src={item?.url?.base64 || item?.url}
                            alt={'image-upload'}
                            className={
                                'w-20 h-20 rounded-md border border-neutral-30 group-hover:border-blue-90 group-hover:opacity-50'
                            }
                        />
                        <div className={'invisible group-hover:visible'}>
                            <img
                                src={icMinusCircle}
                                alt={'ic-minus-circle'}
                                className={'w-4 absolute -top-2 -right-2 cursor-pointer'}
                                onClick={() => onDeleteHandler(index)}
                            />
                            <img
                                draggable={false}
                                src={icDragMove}
                                alt={'ic-drag-move'}
                                className={
                                    'absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-7 cursor-grab'
                                }
                            />
                        </div>
                    </div>
                ))}
                {maxImage > data?.length && (
                    <div
                        className={
                            'flex justify-center py-6 bg-blue-5 hover:bg-blue-20 border border-blue-90 rounded-md'
                        }
                    >
                        <img
                            src={icAddSquare}
                            alt={'ic-add'}
                            className={'w-7 h-7 cursor-pointer'}
                            onClick={onShowFormUpload}
                        />
                    </div>
                )}
            </div>
            <p className={'italic text-neutral-60'}>{`Maksimal ${maxImage} Foto`}</p>
        </div>
    )
}
